module.exports = __webpack_public_path__ + "static/2019全球人工智能治理年度观察中文版-a84ef8f5fb427a367af3c2c87e172d40.pdf";